<template>
    <div class="d-flex justify-content-between flex-column">
        <div>
            <h4 class="text-primary mt-0 mb-3">{{trans('courses.word-hunter.ref_info_title')}}</h4>
            <p class="mb-3" v-html="trans('courses.word-hunter.ref_info_desk')" />
            <div class="d-flex justify-content-center h-100">
                <img src="/images/word-hunter.svg" class="w-50 my-4" />
            </div>
        </div>
        <div>
            <b-form-checkbox
                class="text-caption text-dark mb-0"
                slot="description"
                v-model="doNotShowAgain"
                :value="true"
            >
                {{trans('courses.word-hunter.ref_info_checkbox')}}
            </b-form-checkbox>
            <div class="d-flex justify-content-end w-100">
                <b-button @click="submitAndCancle" variant="link" class="mr-2">{{trans('courses.word-hunter.ref_info_later')}}</b-button>
                <b-button @click="submitAndStart">{{trans('courses.word-hunter.ref_info_start')}}</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReflectionInfo",
        props: {
            currentStep: Number
        },
        data() {
            return { 
                doNotShowAgain: false
            }
        },
        methods: {
            submitAndStart() {
                if (this.doNotShowAgain === true) {
                    localStorage.setItem('advancedReflectionInfoHide', '1')
                }
                this.$emit('hideModalAndStartRef')
            },
            submitAndCancle() {
                this.$emit('hideModalAndCancleRef')
            }
        }
    }
</script>